import axios from "../../utils/axios"

export const getJobs = async (sort, search) => {
    // console.log("call made");

    const response = await axios.get('/jobs');
    let jobs = response.data;
    // console.log(jobs);
    console.log(sort);
    if (sort == 'low' && jobs) {
        // sort by newest
        console.log(sort);
        jobs = jobs.sort((a, b) => parseInt(a.salary) - parseInt(b.salary));
    }
    if (sort == 'high' && jobs) {
        jobs = jobs.sort((a, b) => parseInt(b.salary) - parseInt(a.salary));
    }
    if (search) {
        jobs = jobs.filter((job) => job.title.toLowerCase().includes(search));
    }

    console.log(jobs);
    return jobs;

}
export const addJob = async (jobData) => {
    try {
        const response = await axios.post('/jobs', jobData);
        const newJob = response.data;
        return newJob;
    } catch (error) {
        throw new Error(error.response.data);
    }
}